import { CHROME_WEB_STORE_LISTING_URL } from '@bt-common/nudges/nudge.types';

const locales: string[] = ['en-US', 'pt-PT', 'es-ES', 'de-DE', 'it-IT', 'fr-FR', 'hi-IN', 'he-IL', 'ar-SA'];
const localeDelimiter: string = "-";
const namespace: string = "common";

/**
 * Master switch for cross-surface auth sync between the browser extension and the web app.
 *
 * When TRUE (default — preserves existing behavior): a login or logout in the extension is
 * mirrored to the web app and vice-versa, via the co-injected content-script bridges
 * (attribution-bridge + contentMessageService) which relay set-token / web-logout to the
 * background and fan background broadcasts out to the page world as bt-extension-login /
 * bt-extension-logout.
 *
 * When FALSE: the content-script bridges become inert for auth — the extension and the web
 * app no longer affect each other's login/logout state (each manages its own session).
 */
const isSyncLoginLogoutEnable: boolean = true

/** The ONE Chrome Web Store listing URL (#787: consolidated from three slugs). Reviews tab lives in bt-common's REVIEW_ASK_REVIEW_URL. */
// One store link for every surface: owned by bt-common (the review-ask reviews URL derives from it).
const CHROME_WEB_STORE_URL = CHROME_WEB_STORE_LISTING_URL;

export { locales, localeDelimiter, namespace, isSyncLoginLogoutEnable, CHROME_WEB_STORE_URL };
